import { YieldFetcher } from '../../types'

const USDZEROPLUS_URL = 'https://app.usual.money/api/rewards/rates/USD0++'
const ETHZERO_URL = 'https://app.usual.money/api/rewards/rates/ETH0'

const usdZeroPlus = 'Staked USD0::USD0++'
const ethZero = 'ETH0::ETH0'

export const usdZeroPlusFetcher: YieldFetcher = {
  label: 'USDZEROPLUS',
  fetch: async () => {
    const res = await fetch(USDZEROPLUS_URL, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    }).then((r) => r.json())
    return { [usdZeroPlus]: Number(res?.rewards[0]?.apr ?? 0) * 100 }
  },
}

export const ethZeroFetcher: YieldFetcher = {
  label: 'ETHZERO',
  fetch: async () => {
    const res = await fetch(ETHZERO_URL, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    }).then((r) => r.json())
    return { [ethZero]: Number(res?.rewards[0]?.apr ?? 0) * 100 }
  },
}
